<template>
    <div>
        <div class="title"> 企业用户登录 </div>
        <div>
            <div class="input-box" :class="{
                error: !!phoneError
            }">
                <input v-model="phone" type="text"  placeholder="请输入您的手机号">
            </div>
            <div class="tips">您的手机尚未注册，请验证手机登录</div>
            <div class="captcha flex flex-between m-b-10">
                <div class="input-box" :class="{
                    error: !!captchaError
                }">
                    <input v-model="captcha" type="text"  placeholder="请输入图形验证码">
                </div>
                <div class="captcha-img m-l-10"  @click="captchasrc = '/wapi/base/captcha?'+(new Date).getTime()">
                    <img :src="captchasrc">
                </div>
            </div>
            <div class="input-box reg-ms flex" :class="{
                error: !!verifyError
            }">
                <input v-model="verifyCode" type="text"  placeholder="请输入验证码">
                <div class="ms-text flex-shrink" @click="onSend">
                    {{time >= 0 ? '还剩 '+ time +' 秒' : '发送验证码'}}
                </div>
            </div>
            <div class="tips" :class="{error: phoneError || captchaError || verifyError}">{{captchaError || verifyError}}</div>
            <div class="primary-btn" @click="checkLogin">立即登录/注册</div>
        </div>
    </div>
</template>
<script>
const qs = require('qs');
export default {
    data () {
        return {
            phone: '',
            captcha: '',
            verifyCode: '',

            phoneError: '',
            captchaError: '',
            verifyError: '',


            captchasrc: '/wapi/base/captcha', //图片验证码地址
            time: -1,
            timer: null
        }
    },
    created () {
        this.phone = this.$route.query.phone
    },
    methods: {
        onSend () {
            let time = this.time;
            if(time < 0){
                const url = '/wapi/hr/getRegCode?phone=' + this.phone + '&captcha=' + this.captcha;
                this.axios.get(url)
                    .then(response => {
                        if (response.status * 1 == 200) {
                            this.time = time = 60;
                            this.timer = setInterval(()  => {
                                this.time = time = time - 1
                                if (time < 0) {
                                    clearInterval(this.timer)
                                }
                            }, 1000)
                        }else{
                            this.captchasrc = '/wapi/base/captcha?'+(new Date).getTime()
                        }
                    })
                
            }
        },
        checkLogin () {
            const phone = this.phone
            if( phone.length == 0 ){
                this.phoneError = '请输入手机号';
                return
            } else if( phone.length != 11 ) {
                this.phoneError = '手机号格式不正确';
                return
            } else {
                this.phoneError = ''
            }
            const url = '/wapi/hr/reg/simple';
            if (!this.captcha.length) {
                this.captchaError = '请输入图片验证码';
                return
            } 
            this.captchaError = ''
            if (!this.verifyCode.length) {
                this.verifyError = '请输入验证码';
                return
            }
            this.verifyError = ''
            this.axios.post(url,qs.stringify({
                phone: phone,
                verifyCode :this.verifyCode
            }))
                .then((res)=>{
                    if(res.status*1 == 200 || res.status == 101){
                        this.$router.push({path:'/register/step'});
                    }
                })
        }
    }
}
</script>
<style lang="less" scoped>
@import url('../../assets/less/login.less');
</style>


// WEBPACK FOOTER //
// register.vue?284f004c